import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button } from 'components';
import { RiArrowRightCircleFill } from 'react-icons/ri';

function Engage({
  title,
  titleColor,
  description,
  descriptionColor,
  button,
  backgroundColor,
  backgroundImage,
  overlay,
  options
}) {
  return (
    <div
      className={clsx('relative bg-cover bg-center bg-no-repeat p-8')}
      style={{ backgroundColor, backgroundImage: `url(${backgroundImage})` }}
    >
      {overlay.enabled && (
        <div
          className={clsx('absolute inset-0')}
          style={{ backgroundColor: overlay.color, opacity: overlay.opacity }}
        />
      )}
      <div
        className={clsx(
          {
            'items-start': options.align === 'left',
            'items-center': options.align === 'center',
            'items-end': options.align === 'right'
          },
          'mx-auto flex flex-col justify-center gap-8'
        )}
        style={{
          height: options.height,
          minHeight: options.minHeight,
          maxWidth: options.maxWidth
        }}
      >
        {title && (
          <h1
            className={clsx('z-10 m-0 text-[22px] font-bold md:text-2xl')}
            style={{ color: titleColor }}
          >
            {title}
          </h1>
        )}
        {description && (
          <p
            className={clsx('z-10 m-0 text-sm')}
            style={{ color: descriptionColor }}
          >
            {description}
          </p>
        )}
        {button.text && (
          <div className={clsx('z-10')}>
            <Button
              variant={button.variant}
              onClick={() => (window.location.href = button.link)}
              icon={
                button.icon ? (
                  <RiArrowRightCircleFill className={clsx('h-6 w-6')} />
                ) : null
              }
            >
              {button.text}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

Engage.propTypes = {
  /** Specifies the Text displayed in the Title. */
  title: PropTypes.string,
  /** Specifies the Text color of the Title. */
  titleColor: PropTypes.string,
  /** Specifies the Text displayed in the Description. */
  description: PropTypes.string,
  /** Specifies the Text color of the Description. */
  descriptionColor: PropTypes.string,
  /** Specifies the Options related to the Button. */
  button: PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    icon: PropTypes.bool
  }),
  /** Specifies the Background Color of the Engage Component. */
  backgroundColor: PropTypes.string,
  /** Specifies the Background Image of the Engage Component. */
  backgroundImage: PropTypes.string,
  /** Specifies the Options related to the Overlay. */
  overlay: PropTypes.shape({
    enabled: PropTypes.bool,
    color: PropTypes.string,
    opacity: PropTypes.number
  }),
  /** Specifies the Options related to the Engage Component. */
  options: PropTypes.shape({
    align: PropTypes.oneOf(['left', 'center', 'right']),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

Engage.defaultProps = {
  title: undefined,
  titleColor: '#000000',
  description: undefined,
  descriptionColor: '#000000',
  button: {
    text: undefined,
    link: '#',
    variant: 'primary',
    icon: false
  },
  backgroundColor: '#FFFFFF',
  backgroundImage: '',
  overlay: {
    enabled: false,
    color: '#000000',
    opacity: 0.5
  },
  options: {
    align: 'left',
    height: 'auto',
    maxWidth: 1280,
    minHeight: 0
  }
};

export default Engage;
